import db from "../db/database";
import { getCompanies } from "../utils/businessCentralUtils";
import { isOnline } from "./syncService";

export const getCompanyByName = async (name) => {
    try {
        const company = await db.companies
            .filter(c => c.name === name)
            .first();

        return company;
    } catch (error) {
        return null;
    }
};

export const fetchCompanies = async () => {
    if (!isOnline()) {
        return false;
    }

    try {
        const count = await db.companies.count();
        if (count > 0) return true; // ya está sincronizado, no volvemos a hacer fetch

        const companies = await getCompanies();
     
        companies.forEach(company => {
            db.companies.add({
                bcID: company.id,
                name: company.name,
                displayName: company.displayName,
                lastModified: new Date(),
                lastSynced: new Date()
            })
        });

        return true;
    } catch (error) {
        return false;
    }
};
